import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import "./Play_component.css";
import { msgPromtsuccess,loaderActionSlice,update_user_bal } from "../features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import ModalPopup from "./Popup";
import axios from "axios";
import { API_BASE_URL,checkTime } from "../constant/constant";
import { useT } from "../i18n";



const PlayComponent = () => {
    
    const { gameName,gameType } = useParams(); // Access the dynamic parameter
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {Info,all_games}=useSelector((state)=>state.users);
    const today = new Date();
    const dispatch=useDispatch();
    const navigate=useNavigate();
    const { t } = useT();
    const formattedDate = (today.getMonth() + 1).toString().padStart(2, '0') + '/' + today.getDate().toString().padStart(2, '0') + '/' + today.getFullYear();
    const [selectedPoint, setSelectedPoint] = useState(0);
    const [session, setSession] = useState('Open');
    const [myBids, setMyBids] = useState({});
    const [myBidsErrors, setMyBidsErrors] = useState({});
    const [sessionval, setSessionval] = useState({
        'Open':'OPEN',
        'Close':'CLOSE',
});
let timer;

    const obj={
        single_digit:[1,2,3,4,5,6,7,8,9,0],
        jodi_digit: [
            "00", "01", "02", "03", "04", "05", "06", "07", "08", "09",
            "10", "11", "12", "13", "14", "15", "16", "17", "18", "19",
            "20", "21", "22", "23", "24", "25", "26", "27", "28", "29",
            "30", "31", "32", "33", "34", "35", "36", "37", "38", "39",
            "40", "41", "42", "43", "44", "45", "46", "47", "48", "49",
            "50", "51", "52", "53", "54", "55", "56", "57", "58", "59",
            "60", "61", "62", "63", "64", "65", "66", "67", "68", "69",
            "70", "71", "72", "73", "74", "75", "76", "77", "78", "79",
            "80", "81", "82", "83", "84", "85", "86", "87", "88", "89",
            "90", "91", "92", "93", "94", "95", "96", "97", "98", "99"
          ],
          single_pana:[
            127, 136, 145, 190, 235, 280, 370, 479, 460, 569, 389, 578,
            128, 137, 146, 236, 245, 290, 380, 470, 489, 560, 678, 579,
            129, 138, 147, 156, 237, 246, 345, 390, 480, 570, 679, 589,
            120, 139, 148, 157, 238, 247, 256, 346, 490, 580, 670, 689,
            130, 149, 158, 167, 239, 248, 257, 347, 356, 590, 680, 789,
            140, 159, 168, 230, 249, 258, 267, 348, 357, 456, 690, 780,
            123, 150, 169, 178, 240, 259, 268, 349, 358, 457, 367, 790,
            124, 160, 179, 250, 269, 278, 340, 359, 368, 458, 467, 890,
            125, 134, 170, 189, 260, 279, 350, 369, 378, 459, 567, 468,
            126, 135, 180, 234, 270, 289, 360, 379, 450, 469, 478, 568
          ],
          double_pana: [
            550, 668, 244, 299, 226, 488, 677, 118, 334,
            100, 119, 155, 227, 335, 344, 399, 588, 669,
            200, 110, 228, 255, 336, 499, 660, 688, 778,
            300, 166, 229, 337, 355, 445, 599, 779, 788,
            400, 112, 220, 266, 338, 446, 455, 699, 770,
            500, 113, 122, 177, 339, 366, 447, 799, 889,
            600, 114, 277, 330, 448, 466, 556, 880, 899,
            700, 115, 133, 188, 223, 377, 449, 557, 566,
            800, 116, 224, 233, 288, 440, 477, 558, 990,
            900, 117, 144, 199, 225, 388, 559, 577, 667
          ],
          triple_pana:['000',111,222,333,444,555,666,777,888,999],


    }
    // Array for points
    const digits =obj[gameType]; // Digits 0-9
  
    const groupedDigits = [];
    for (let i = 0; i < digits.length; i += 3) {
      groupedDigits.push(digits.slice(i, i + 3));
    }
    const handlePointClick = (point) => {
      setSelectedPoint(point);
    };

    useEffect(()=>{
        let validate=false;
        all_games?.forEach((value)=>{
            if(value?.games_name.split(' ').join('_') === gameName){
                validate=checkTime(value?.open_time);
            }
        })
        if(!validate){
            setSession('Close');
            setSessionval((currentSession) => {
              if (!Object.prototype.hasOwnProperty.call(currentSession, 'Open')) {
                return currentSession;
              }
              const nextSession = { ...currentSession };
              delete nextSession.Open;
              return nextSession;
            });
        }
    },[all_games,gameName]);

    const handleMouseDown = (num) => {
      // Start a timer for the long press
      timer = setTimeout(() => {
        let obj={...myBids};
        delete obj[num];
        setMyBids({...obj});
      }, 1400); // 1000ms = 1 second
    };
  
    const handleMouseUp = () => {
      clearTimeout(timer);
    };
  
    const handleMouseLeave = () => {
      clearTimeout(timer);
    };

    const addMyBid=(num)=>{
        if(selectedPoint && parseInt(selectedPoint)){
          if(parseInt(selectedPoint)>=10){
          setMyBids({...myBids,[num]:parseInt((myBids[num] || 0)) + parseInt(selectedPoint)});
          }else{
            dispatch(msgPromtsuccess({msg:`Please Enter minimum 10 Points.`,error:true}));
          }
        }else{
            dispatch(msgPromtsuccess({msg:`Please Enter Points for Betting.`,error:true}));
        }
    }

    const toTitleCase=(str)=>{
        return str
          .toLowerCase() // Convert the entire string to lowercase
          .split(/\s+/) // Split the string by spaces
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
          .join(" "); // Join the words back together with a single space
      }
  
    
    const  sumOfDigits=(number)=> {
        return number
          .toString() // Convert number to string
          .split("") // Split string into individual digits
          .map(Number) // Convert each character back to a number
          .reduce((acc, digit) => acc + digit, 0) % 10 || '0'; // Sum up the digits
      }
      

    const gameMainLogin=(key)=>{
        if(gameType==='single_digit'){
            let closes=(session==='Close')?true:false;
             return {
                'open_pana':'NA',
                'open_digit':closes?'NA':key||'0',
                'close_pana':'NA',
                'close_digit':closes?key:'NA',
             }
        }else if(gameType==='jodi_digit'){
            const digits = key.toString().split("").map(Number);
            return {
                'open_pana':'NA',
                'open_digit':digits[0]||'0',
                'close_pana':'NA',
                'close_digit':digits[1] || '0',
             }
        }else if(gameType==='single_pana'){
            let closes=(session==='Close')?true:false;
            return {
               'open_pana':closes?'NA':key,
               'open_digit':closes?'NA':sumOfDigits(key),
               'close_pana':closes?key:'NA',
               'close_digit':closes?sumOfDigits(key):'NA',
            }
        }else if(gameType==='double_pana'){
            let closes=(session==='Close')?true:false;
            return {
               'open_pana':closes?'NA':key,
               'open_digit':closes?'NA':sumOfDigits(key),
               'close_pana':closes?key:'NA',
               'close_digit':closes?sumOfDigits(key):'NA',
            }

        }else if(gameType==='triple_pana'){
            let closes=(session==='Close')?true:false;
            return {
               'open_pana':closes?'NA':key,
               'open_digit':closes?'NA':sumOfDigits(key),
               'close_pana':closes?key:'NA',
               'close_digit':closes?sumOfDigits(key):'NA',
            }

        }
    }
     // Function to handle opening modal
  const openModal = () => {
    if(Object.keys(myBids).length){
    setIsModalOpen(true);
    }else{
        dispatch(msgPromtsuccess({msg:`Please Select Bids for Betting.`,error:true}));
    }
  };

  // Function to handle closing modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  
    const handleSubmit = async() => {
        dispatch(loaderActionSlice(true));
        Object.keys (myBids).forEach((key) => {
            setMyBidsErrors((prev)=>({...prev,[key]:'HOLD'}));
         });
        let remain_ammount=false;
        let userAccountZero=false;
        let isError=false;

         await Object.keys(myBids).reduce(async (previousPromise, key) => {
            // Wait for the previous request to finish
            await previousPromise;
                let myDigits=gameMainLogin(key);
              let dataObject={
                  'phone_number':Info?.phone_number,
                  'game_name':toTitleCase(gameName.split('_').join(' ')),
                  'game_type':toTitleCase(gameType.split('_').join(' ')),
                  'session':toTitleCase(session),
                  'open_pana':myDigits?.open_pana || 'NA',
                  'open_digit':myDigits?.open_digit || 'NA',
                  'close_pana':myDigits?.close_pana || 'NA',
                  'close_digit':myDigits?.close_digit || 'NA',
                  'points_action':myBids[key],
              }


              try {
                // Send POST request
                setMyBidsErrors((prev)=>({...prev,[key]:'LOADING...'}));
                     const response = await axios.post(
                        `${API_BASE_URL}set_bid_new.php`, // Replace with your PHP endpoint
                        new URLSearchParams({
                          bids: JSON.stringify([dataObject]), // Convert bids array/object to a JSON string
                        }),
                        {
                          headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                          },
                        }
                      );
               
                if(response.data.success && response.data.success!=='0'){
                    setMyBidsErrors((prev)=>({...prev,[key]:'Success'}));
                        remain_ammount=response.data?.Remaining_user_balance || false; 
                        if(response.data?.Remaining_user_balance===0){
                            userAccountZero=true;
                            
                        } 
                                          
                }else{
                    let error=response?.data?.msg || 'Failed';
                setMyBidsErrors((prev)=>({...prev,[key]:error}));
                isError=true;

                }
              } catch (error) {
                setMyBidsErrors((prev)=>({...prev,[key]:'Failed !!'}));
                isError=true;

              }finally{
                dispatch(loaderActionSlice(false));
              }

            }, Promise.resolve());        
            
          if(remain_ammount || userAccountZero){
             dispatch(update_user_bal(userAccountZero?0:remain_ammount));
            if(!isError)navigate('/my-bid');
          }
    };
  
    return (
      <div className="all_bids" style={{backgroundColor:'#ffffff'}}>
        <div className="header" style={{justifyContent:'space-between'}}>
          <input style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}} type="text" value={formattedDate} className="date-input" readOnly />
          <select style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}} className="dropdown" id={session} onChange={(event)=>{setSession(event.target.value);setMyBids({});}}>
           {
             Object.keys(sessionval).map((key) => (
                <option key={key} value={key}>{t(key)}</option>
            ))}
          </select>
        </div>
        <div className="points-section" style={{textAlign:'left',paddingLeft:'6%'}}>
          <input placeholder={t("Enter points")} style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}} type="number" onChange={(e)=>handlePointClick(e.target.value)} className="date-input" />
          
        </div>

        <br/>
  
       {groupedDigits.map((group, index) => (
        <><div className="digits-section" key={index}>
          {group.map((digit) => (
            <>
            <div 
              style={{cursor:'pointer'}}
              key={digit} 
              className="digit-box" 
              onClick={()=>addMyBid(digit)}
              onMouseDown={()=>handleMouseDown(digit)}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseLeave}
             >
              <span style={{color:'#007bff'}}>{myBids[digit]||''}</span>
              <label>{digit}</label>
              {/* <input  style={{cursor:'pointer'}}readOnly={true} type="text"  onClick={()=>addMyBid(digit)} value={myBids[digit]||''}/> */}
            </div>&nbsp;&nbsp;&nbsp;</>
          ))}
        </div><br/></>
          ))}
  
        {/* Buttons */}
        <div className="button_container">
          <div className="footerBid" >
            <span className="footerBid_span">{Object.keys(myBids).length}</span>
            <span style={{color:'gray'}}>{t('Bids')}</span>
          </div>
          <div className="footerBid">
            <span className="footerBid_span">{Object.values(myBids).reduce((acc, value) => acc + value, 0)}</span>
            <span style={{color:'gray'}}>{t('Points')}</span>
          </div>
              <button  style={{width:'40%'}}  className="continue-button" onClick={openModal}>
            {t('Submit Bid')}
          </button>
        </div>
         {/* Modal Component */}
     
        <ModalPopup 
         isOpen={isModalOpen}
         closeModal={closeModal} 
         betData={myBids} 
         session={session}
         gameName={gameName}
         handleSubmit={handleSubmit}
         myBidsErrors={myBidsErrors}
         />
         <br/><br/><br/><br/>
      </div>
    );
};

export default PlayComponent;
